// const MODIFIERS = ['login']

export function is (val, type) {
  return toString.call(val) === `[object ${type}]`
}
export const isFun = v => typeof v === 'function' || false
export const isObject = (val) => val !== null && is(val, 'Object')

export const track = (_, binding, vnode) => {
  const { value, modifiers } = binding
  const { context } = vnode

  const sendLog = (val = {}) => {
    const { eventType, data } = val
    console.log(`📃LOG:${eventType}`, data)
    context.$track.sendTrack(eventType, data)
  }

  if (modifiers.login && isObject(value) && value) {
    context.$track.loginLog(value).then(data => {
      sendLog({ eventType: 'login', data })
    })
  }

  if (value && isObject(value) && value?.eventType && value?.data) {
    if (modifiers.watch) {
      console.log('SEND_CUSTOM_WATCH_LOG', value?.data)
      sendLog(value)
    } else {
      sendLog(value)
    }
  }
}
